<template>
  <div>
    <el-button type="warning" size="medium" @click="SMSLink"
      >短信链接列表</el-button
    >
    <el-dialog
      title="短信链接列表"
      ref="SMSLinkRef"
      :visible.sync="dialogFormVisible"
      class="SMSLink-dialog"
      width="70%"
      :before-close="dialogClose"
    >
      <el-row>
        <el-form size="medium" :inline="true" :model="searchCondition">
          <el-form-item label="姓名">
            <el-input
              v-model="searchCondition.name"
              placeholder="输入姓名"
              class="item-name"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              v-model="searchCondition.mobile"
              placeholder="输入手机号"
              class="item-name"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="时间">
            <DatePicker @dataSearch="dataSearch" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchButton">查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <ApeTable
        ref="apeTable"
        :columns="columns"
        :loading="loadingStatus"
        :pagingData="pagingData"
        :data="SMSLinkList"
        @switchPaging="switchPaging"
      >
        <el-table-column align="center" label="链接">
          <template slot-scope="scope">
            <div>
              <div class="code-text">{{ scope.row.content }}</div>
              <el-button
                class="searchBtnQYLink"
                type="text"
                @click="copyText(scope.row.content)"
                >复制链接</el-button
              >
            </div>
          </template>
        </el-table-column>
      </ApeTable>
    </el-dialog>
  </div>
</template>
<script>
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";

export default {
  components: {
    ApeTable,
    DatePicker,
  },
  props: {},
  data() {
    return {
      searchCondition: {},
      dialogFormVisible: false,
      loadingStatus: false,
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        page_size: 10,
      },
      // 退款数据
      SMSLinkList: [],
      columns: [
        {
          title: "姓名",
          value: "name",
          width: 200,
          header_align: "center",
          align: "center",
        },
        {
          title: "手机号",
          value: "mobile",
          width: 200,
          header_align: "center",
          align: "center",
        },
        {
          title: "时间",
          value: "created_at",
          width: 200,
          header_align: "center",
          align: "center",
        },
      ],
    };
  },
  computed: {},
  methods: {
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    async copyTextToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    },
    copyText(text) {
      this.copyTextToClipboard(text);
      this.$message.success("复制成功");
    },
    dialogClose() {
      this.$refs["apeTable"]?.setCurrentChange(1);
      this.dialogFormVisible = false;
    },
    async SMSLink() {
      this.dialogFormVisible = true;
      this.initData();
    },
    async initData() {
      this.dialogFormVisible = true;
      this.loadingStatus = true;
      let pagingInfo = this.$refs["apeTable"]?.getPagingInfo() || {
        current_page: 1,
        page_size: 10,
      };
      let param = {
        ...pagingInfo,
        ...this.searchCondition,
      };
      if (this.searchCondition.time_value) {
        param.start_time = this.searchCondition.time_value[0];
        param.end_time = this.searchCondition.time_value[1];
        delete param.time_value;
      }
      const result = await this.$api.getSMSLinkList(param);
      this.SMSLinkList = result.data;
      this.pagingData.total = result.pages.total;
      this.offset = result.pages.offset;
      this.loadingStatus = false;
    },
    // 切换分页
    async switchPage() {
      this.dialogFormVisible = true;

      this.SMSLink(pagingInfo);
    },
    async switchPaging() {
      await this.initData();
    },
    async searchButton() {
      this.$refs["apeTable"]?.setCurrentChange(1);
      await this.initData();
    },
  },
};
</script>
<style scoped>
.SMSLink-dialog /deep/ .el-dialog .el-dialog__body {
  padding: 30px 30px !important;
}

.SMSLink-dialog /deep/ .el-dialog .el-dialog__header span {
  display: inline-block;
  border-left: 5px solid #1890ff;
  padding-left: 10px;
  height: 24px;
  color: #101010;
}

.SMSLink-dialog /deep/ .el-dialog .el-dialog__header {
  padding-bottom: 20px !important;
}

.SMSLink-dialog /deep/ .el-dialog .el-dialog__body {
  padding-top: 0 !important;
}
>>> .el-dialog {
  margin-top: 5vh !important;
  overflow: scroll;
  height: 800px;
}
</style>
